import coreIcon from '../components/icons/coreIcon'
import financeIcon from '../components/icons/financeIcon'
import operationsIcon from '../components/icons/operationsIcon'
import patientIcon from '../components/icons/patientIcon'
import staffIcon from '../components/icons/staffIcon'

export default [
    {
        icon: coreIcon,
        number: "1",
        questions: ["111", "112", "113", "114", "115", "116", "121", "122", "123", "124"],
        secId: "core",
        subSections: ["11", "12"],
        summary1: "Does telehealth fit your practice?",
        summary2: "How does leadership feel about it?",
        title: "Core Readiness"
    }, {
        icon: financeIcon,
        number: "2",
        questions: ["211", "212", "213", "214", "215"],
        secId: "finance",
        subSections: ["21"],
        summary1: "Can you afford telehealth?",
        summary2: "Can you afford not to offer it?",
        title: "Financial Considerations"
    }, {
        icon: operationsIcon,
        number: "3",
        questions: ["311", "312", "313", "314", "321", "322", "323", "324", "325", "331", "332", "333", "334", "341", "342", "343", "344", "351", "352", "353", "354", "361", "362", "363"],
        secId: "operations",
        subSections: ["31", "32", "33", "34", "35", "36"],
        summary1: "Are you prepared for telehealth?",
        summary2: "What do you need to get started?",
        title: "Operations"
    }, {
        icon: staffIcon,
        number: "4",
        questions: ["411", "412", "413", "421", "422", "423", "424"],
        secId: "staff",
        subSections: ["41", "42"],
        summary1: "How do staff feel about telehealth?",
        summary2: "Are they willing and engaged?",
        title: "Staff Engagement"
    }, {
        icon: patientIcon,
        number: "5",
        questions: ["511", "512", "513", "514", "515", "521", "522", "523"],
        secId: "patient",
        subSections: ["51", "52"],
        summary1: "Is telehealth right for your patients?",
        summary2: "Is this what they want?",
        title: "Patient Readiness"
    }
]


// WEBPACK FOOTER //
// ./src/data/sections.js